module.exports = __webpack_public_path__ + "images/sprites/ui/headline_icon_bk_5a871ffc6708ed3e441fc20d41c36de4.png";